import { render, staticRenderFns } from "./GheibatSingle.vue?vue&type=template&id=2ace3d18&scoped=true"
import script from "./GheibatSingle.vue?vue&type=script&lang=js"
export * from "./GheibatSingle.vue?vue&type=script&lang=js"
import style0 from "./GheibatSingle.vue?vue&type=style&index=0&id=2ace3d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ace3d18",
  null
  
)

export default component.exports